import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import IdSearchForm from './IdSearchForm';
import IdSearchResult from './IdSearchResult';
import {PageContainer, PageDescription, PageTitle} from '../../Common/PageComponents';

class IdSearch extends Component {
  render() {
    return (
      <PageContainer>
        <PageTitle title="아이디 찾기" />
        <PageDescription>
          사용하시는 아이디를 잊으셨나요? <br />
          가입 시 입력하신 대표자 성명과 사업자등록번호로 확인해주세요.
        </PageDescription>
        <Route exact path="/member-service/id-search" component={IdSearchForm} />
        <Route path="/member-service/id-search/result" component={IdSearchResult} />
      </PageContainer>
    );
  }
}

export default IdSearch;
